import {
  marketingCodeLookup,
  marketingTypeLookup
} from 'utils/lookups';
import {DetailsControlType} from 'shared/details-page/details-control/details-control-type';

/* eslint-disable */
export const marketingCopySegmentData: any = [
  { // ZZZ-NAME
    'field_map': 'name',
    'item_name': 'name',
    'title': 'Name',
    'hint_detail': 'Name',
    'hint_panel': 'Name',
    'example': '',
    'sequence': 1,
    'show_more': true,
    'lookup': null,
    'validation': {
      'PIES_6_5' : {
        required: true,
        minLength: 2,
        message: 'Name must be provided and is limited to 2 characters'
      },
    },
  },
  { // A82
    'field_map': 'code',
    'item_name': 'code',
    'title': 'Reference Type',
    'hint_detail': 'Used to apply marketing copy to product group or series, part type a brand, sub-brand, or an entire company.',
    'hint_panel': 'Select which reference type level to apply the marketing copy. Separate marketing copies can be created for each level.',
    'example': '',
    'sequence': 3,
    'show_more': true,
    'lookup': marketingCodeLookup,
  },
  {  // A83
    'field_map': 'reference',
    'item_name': 'reference',
    'title': 'Assignment',
    'hint_detail': 'Used to apply marketing copy to product group or series, part type a brand, sub-brand, or an entire company.',
    'hint_panel': 'Select the brand, product group or series, or part type to apply the marketing copy.',
    'example': '',
    'sequence': 5,
    'show_more': true,
    'lookup': null // Dynamic list of options
  },
  { // A85
    'field_map': 'subCodeReference',
    'item_name': 'sub_code_reference',
    'title': 'Sub Assignment',
    'hint_detail': 'Used to apply marketing copy to product group or series, part type a brand, sub-brand, or an entire company.',
    'hint_panel': 'Select the brand, product group or series, or part type to apply the marketing copy.',
    'example': '',
    'sequence': 6,
    'show_more': true,
    'lookup': null // Dynamic list of options
  },
  { // A86
    'field_map': 'type',
    'item_name': 'type',
    'title': 'Copy Type',
    'hint_detail': 'IDK YET Please fix me',
    'hint_panel': 'IDK YET Please fix me',
    'example': '',
    'sequence': 3,
    'show_more': true,
    'lookup': marketingTypeLookup,
  },
  { // A87 & A89
    'field_map': 'value',
    'item_name': 'value',
    'title': 'Copies',
    'hint_detail': 'Up to 2,000 characters. Descriptive marketing copy listing features and benefits of products, or value proposition of the brand. More than one copy can be used; the order entered will be the order delivered.',
    'hint_panel': 'Up to 2,000 characters. Descriptive marketing copy listing features and benefits of products, or value proposition of the brand. More than one copy can be used; the order entered will be the order delivered.',
    'example': '',
    'sequence': 7,
    'show_more': true,
    'lookup': null,
    'validation': {
      'PIES_6_5' : {
        maxLength: 2000,
        message: 'General Copy is limited to 2000 characters'
      },
    }
  },
  { // ???
    'field_map': 'digitalAssets',
    'item_name': 'digitalAssets',
    'title': 'Digital Assets',
    'hint_detail': '',
    'hint_panel': '',
    'example': '',
    'sequence': 8,
    'show_more': true,
    'lookup': null,
    'type': DetailsControlType.Asset,
  }
];
/* eslint-enable */
